import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { History } from '@df/session/api/history/history';

@Injectable({
    providedIn: 'root'
})
export class CustomerHistoryResolver implements Resolve<History> {
    constructor(private history: History) {}

    resolve(): Promise<History> {
        return this.history.load();
    }
}
